// Retention plan (Task 21) — CLOCKS ONLY. These types mirror the backend
// `src/retention/types.ts` shapes. Nothing here deletes anything.

export type RetentionRecordType =
  | 'ENROLLMENT'
  | 'ATTENDANCE'
  | 'INCIDENT'
  | 'MEDICATION'
  | 'FIRE_DRILL'
  | 'COMPLAINT'
  | 'STAFF_VETTING'
  | 'FINANCIAL'
  | 'POLICY_REVIEW'
  | 'CHILD_PROTECTION';

export type RetentionTrigger = 'CHILD_LEFT' | 'RECORD_CREATED';

export type RetentionRuleSource = 'DEFAULT' | 'ORG' | 'LOCATION';

export interface ResolvedRetentionRule {
  recordType: RetentionRecordType;
  /** Months kept from the trigger; `null` = HOLD (retained indefinitely). */
  periodMonths: number | null;
  trigger: RetentionTrigger;
  /** Rendered verbatim beside the editable period — the honesty requirement. */
  provenance: string;
  source: RetentionRuleSource;
}

export interface RetentionOverviewRow {
  recordType: RetentionRecordType;
  trigger: RetentionTrigger;
  periodMonths: number | null;
  provenance: string;
  /** Records past their computed expiry (informational; 0 for HOLD / not enumerated). */
  pastExpiryCount: number;
  /** Children currently excluded from the count because a legal hold froze their clocks. */
  heldCount: number;
  /** Whether this type's records are actually enumerated in v1 (record-scoped types are not). */
  enumerated: boolean;
}

export interface StudentLegalHold {
  reason: string;
  setBy: string;
  setAt: string;
}

/** Human labels for the record types, for table rows / headings. */
export const RETENTION_RECORD_TYPE_LABELS: Record<RetentionRecordType, string> = {
  ENROLLMENT: 'Enrollment records',
  ATTENDANCE: 'Attendance records',
  INCIDENT: 'Incident records',
  MEDICATION: 'Medication records',
  FIRE_DRILL: 'Fire-drill logs',
  COMPLAINT: 'Complaints',
  STAFF_VETTING: 'Staff vetting / references / credentials',
  FINANCIAL: 'Financial / billing records',
  POLICY_REVIEW: 'Policy reviews',
  CHILD_PROTECTION: 'Child-protection records',
};
